import { render, staticRenderFns } from "./JobsReviewProjectManagers.vue?vue&type=template&id=2cb82938&scoped=true&"
import script from "./JobsReviewProjectManagers.vue?vue&type=script&lang=js&"
export * from "./JobsReviewProjectManagers.vue?vue&type=script&lang=js&"
import style0 from "./JobsReviewProjectManagers.vue?vue&type=style&index=0&id=2cb82938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb82938",
  null
  
)

export default component.exports